export const INVALID_UPDATE_AUTHORIZATION = "수정권한이 없습니다."
export const INVALID_POST_AUTHORIZATION = "등록권한이 없습니다."
export const INVALID_DELETE_AUTHORIZATION = "삭제권한이 없습니다."